import { memo, ReactNode } from 'react';

import s from './styles.module.scss';

interface PopoverButtonProps {
  children: ReactNode;
  onClick: () => void;
}

const PopoverButton = ({ children, onClick }: PopoverButtonProps) => (
  <button className={s.popoverButton} onClick={onClick}>
    {children}
  </button>
);

export const PopoverButtonMemo = memo(PopoverButton);
